// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams } from 'react-router-dom';
import '../../assets/style/common.css';
import '../../assets/style/admin.css';







const lang = Util.get_lang();

export default () => {

    // const navigate = useNavigate();
    
    const [searchParams, setSearchParams] = useSearchParams();
    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
            case 'error': setToastModeIcon(<WarningIcon sx={{ fontSize: '32px', color: '#a0a0a0' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }
    const [keyword, setKeyword] = useState('');
    const [listPagePanel, setListPagePanel] = useState({ current_page: 0, pages: [], prev_section: false, next_section: false });
    const [dataList, setDataList] = useState([]);
    const [sessionDetailArray, setSessionDetailArray] = useState([]);
    const [flagDataDetail, setFlagDataDetail] = useState('none');
    const [flagSessDetail, setFlagSessDetail] = useState([]);
    





    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_NOTICE_LIST']]);
        load_data_list();

    }, []);






    function toggle_detail(idx) {
/*
        let t_array = [];

        for (let i = 0; i < flagSessDetail.length; i++) {

            let t_flag = flagSessDetail[i];

            if (i == idx) {
                if (t_flag == 'none') {
                    t_flag = '';
                    update_session_detail_flag(userList[idx].id, true);
                } else {
                    t_flag = 'none';
                    update_session_detail_flag(userList[idx].id, false);
                }
            }

            t_array[i] = t_flag;
        }

        setFlagSessDetail(t_array);*/
    }






    function update_session_detail_flag(sess_id, flag) {

        let t_array = [];


        if (flag) {
            // Add.

            let flag_exists = false;
            for (let i = 0; i < sessionDetailArray.length; i++) {
                if (sessionDetailArray[i] == sess_id) {
                    flag_exists = true;
                }

                t_array.push(sessionDetailArray[i]);
            }

            if (!flag_exists) { t_array.push(sess_id); }

        } else {
            // Remove.

            for (let i = 0; i < sessionDetailArray.length; i++) {
                if (sessionDetailArray[i] != sess_id) {
                    t_array.push(sessionDetailArray[i]);
                }
            }

        }

        setSessionDetailArray(t_array);
    }











    function update_user_app_session(id, col, val) {

        const form = {
            name: col,
            value: val
        }

        Util.post(
            '/ko/api/v1/admin/user/app-session/update/' + id,
            form,
            (data) => {
                showToast('info', UIString[lang]['UPDATED']);
                //load_session_list();
                load_data();
            },
            (error) => {
                //  return: {type,msg}
                document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );
    }





    const load_page = (t) => {
        /*navigate(Config.BASE_URL + '/admin/mobile_app/list/' + t);*/
        window.location.href = Config.BASE_URL + '/admin/corp/list/' + t;
    }


    const start_search = (v) => {

        if (v.trim() == '') {
            alert('Please input search keyword!!');
            return;
        }

        if (!Util.no_special_chars(v)) {
            alert('No special chars!!');
            return;
        }

        let search_query = '';
        let src_query = v.split(' ');
        for (let i = 0; i < src_query.length; i++) {
            if (src_query[i].trim() != '') {
                if (search_query != '') { search_query = search_query + '+'; }
                search_query = search_query + src_query[i].trim();
            }
        }

        window.document.location.href = '/' + lang + '/admin/user/list/1?search=' + search_query;
    }


    const reset_search = () => {
        window.document.location.href = '/' + lang + '/admin/user/list/1';
    }





    function load_data_list() {

        let url = Util.api_url(lang,'/admin/notice/list/');
        let c_page = 1;
        let lines = 20;
        let saerch_keyword = '';
        let query_str = '';

        if (window.location.pathname.split('/').length > 4) {
            c_page = window.location.pathname.split('/')[5];
        }

        url = url + c_page;

        // Lines.
        if (
            searchParams.get('lines') != undefined &&
            searchParams.get('lines') != '' &&
            /([0-9]{1,3})/.test(searchParams.get('lines'))
        ) {
            lines = parseInt(searchParams.get('lines'));
            query_str = url + '?lines='
        }

        // Search keyword.
        if (searchParams.get('search') != undefined && searchParams.get('search') != '') {

            let t_search_str = searchParams.get('search').trim().replaceAll('+', ' ');
            setKeyword(t_search_str);

            if (query_str != '') {
                query_str = query_str + '&search=' + searchParams.get('search').trim();
            } else {
                query_str = query_str + '?search=' + searchParams.get('search').trim();
            }
        }

        // Request url.
        if (query_str != '') {
            url = url + query_str;
        }

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {
                let data_array = [];
                //let sess_detail_array = [];


                for (let i = 0; i < data.list.length; i++) {
                    let data_item = data.list[i];

                    switch (data_item.status) {
                        case 'ACTIVE': data_item.status_chip = <Chip label="ACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222' }} />; break;
                        case 'INACTIVE': data_item.status_chip = <Chip label="INACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#a5a5a5', color: '#ffffff' }} />; break;
                        case 'DELETED': data_item.status_chip = <Chip label="DELETED" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        default: data_item.status_chip = <Chip label="DEFAULT" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#00ff00', color: '#222222' }} />; break;
                    }

                    //data_item.disp = 'none';

                    if( data_item.language == null ){
                        data_item.target = '?:' + data_item.target;
                    }else{
                        data_item.target = data_item.language + ':' + data_item.target;
                    }

                    data_array.push(data_item);
                    //sess_detail_array.push('none');

                }
                setDataList(data_array);
                //setFlagSessDetail(sess_detail_array);
                setListPagePanel({
                    prev_section: data.prev_section,
                    current_page: data.current_page,
                    next_section: data.next_section,
                    pages: data.pages
                });

                if (data_array.length == 0) { setFlagContent('none'); } else { setFlagContent(''); }
            },
            (err) => {
                if( err.error_code == 'LOGIN_REQUIRED' ){
                    alert(err.error);
                    document.location  = Util.page_url(lang,'/');
                }else{
                    showToast(err.error);
                }
            }
        );
    }








    function load_data() {

        let url = '/ko/api/v1/admin/corp/list/1';
        let c_page = 1;
        let lines = 20;
        let saerch_keyword = '';
        let query_str = '';

        if (window.location.pathname.split('/').length > 4) {
            c_page = window.location.pathname.split('/')[5];
        }

        url = url + c_page;

        // Lines.
        if (
            searchParams.get('lines') != undefined &&
            searchParams.get('lines') != '' &&
            /([0-9]{1,3})/.test(searchParams.get('lines'))
        ) {
            lines = parseInt(searchParams.get('lines'));
            query_str = url + '?lines='
        }

        // Search keyword.
        if (searchParams.get('search') != undefined && searchParams.get('search') != '') {

            let t_search_str = searchParams.get('search').trim().replaceAll('+', ' ');
            setKeyword(t_search_str);

            if (query_str != '') {
                query_str = query_str + '&search=' + searchParams.get('search').trim();
            } else {
                query_str = query_str + '?search=' + searchParams.get('search').trim();
            }
        }

        // Request url.
        if (query_str != '') {
            url = url + query_str;
        }

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {
                let sess_array = [];
                let sess_detail_array = [];


                for (let i = 0; i < data.list.length; i++) {
                    let sess_item = data.list[i];

                    switch (sess_item.status) {
                        case 'ACTIVE': sess_item.status_chip = <Chip label="ACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222' }} />; break;
                        case 'INACTIVE': sess_item.status_chip = <Chip label="INACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#a5a5a5', color: '#ffffff' }} />; break;
                        case 'DELETED': sess_item.status_chip = <Chip label="DELETED" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        default: sess_item.status_chip = <Chip label="DEFAULT" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#00ff00', color: '#222222' }} />; break;
                    }

                    sess_array.push(sess_item);
                    //            sess_detail_array.push('none');

                }
               // setUserList(sess_array);
                //  setFlagSessDetail(sess_detail_array);
                /*  setUserListData({
                      prev_section: data.prev_section,
                      current_page: data.current_page,
                      next_section: data.next_section,
                      pages: data.pages
                  });

                  if( sess_array.length == 0 ){ setFlagContent('none'); }else{setFlagContent('');}*/
            },
            (err) => {
                alert(err);
            }
        );
    }

    const add_user = () => {
        alert('add user!!');
    }




    const nav_links = [{ label: 'Home', url: '/ko/admin/dashboard' }, { label: 'Dashboard', url: '/Dashboard' }];

    return (
        <>
            <Header code={'notice'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>
              
                <Stack className='page_title' direction={'col'}>
                    <NavBar text={navTitle} key={navTitle} />
                    <span className='nav_right_button' style={{whiteSpace:'nowrap'}} onClick={()=>{Util.navigate(lang,'/admin/notice/new')}}>{UIString[lang]['ADD']}</span>
                </Stack>


                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>
                    <SearchBar key={keyword} keyword={keyword} start_search={start_search} reset_search={reset_search} />
                    <TableContainer component={Paper} sx={{}}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#f2f2f2' }}>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '80px' }} align='right'>Id</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '60px' }} align="left">Target</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width:'100px' }} align="left">Channel</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align="left">Title</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '118px' }} align="left">created</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '118px' }} align="left">created (UTC)</TableCell>
                                    {/*<TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '93px' }} align="center">Logged In</TableCell>*/}
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px',width:'90px'}} align="center">Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataList.map((item, index) => <><TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#ffffff', cursor: 'pointer', "&:hover": { backgroundColor: '#f8f8f8' } }} onClick={() => { Util.navigate(lang,'/admin/notice/detail/'+item.id) }}>
                                     <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align='right'>{item.id}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow:'hidden',textOverflow:'ellipsis', whiteSpace:'nowrap',wordBreak:'break-all',maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden' }} textOverflow="ellipsis" align="left">{item.target}</TableCell>
                                    <TableCell className='data_list_row' sx={{maxWidth:'100px'}}>{item.channel == null ? 'N/A' : item.channel}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow:'hidden'}} textOverflow="ellipsis" align="left">{item.title}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left">{ item.created != null ? item.created.substr(0,10) : 'N/A'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left" textOverflow="ellipsis">{ item.created_utc != null ? item.created_utc.substr(0,10) : 'N/A'}</TableCell>
                                    {/*<TableCell sx={{ fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis',}} align="center">{item.is_logged_in }</TableCell>*/}
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align="left">{item.status_chip}</TableCell></TableRow></>)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                    <PagePanel
                        sx={{ display: `${flagContent}` }}
                        pages={listPagePanel.pages}
                        current_page={listPagePanel.current_page}
                        prev_section={listPagePanel.prev_section}
                        next_section={listPagePanel.next_section}
                        clicked={load_page}
                    />
                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>









            </div>
        </>
    );

}